import React, { useState } from "react";
import { Button, Form, Input, message, Checkbox } from "antd";
import { Link } from "react-router-dom";

import { sendSignupOTP } from "../actions";
import { routePage } from "../../../utils/constants/constant";
import "../Login.scss";

const RegisterStep1 = ({
  handleChangeStep = () => {},
  handleVisible = () => {},
  dataForm = {},
  handleChangeDataForm = () => {},
}) => {
  const [isRead, setIsRead] = useState(true);
  const onFinish = async (values) => {
    try {
      const { data } = await sendSignupOTP(values);
      if (data.code === 200) {
        handleChangeDataForm({
          ...dataForm,
          ...values,
        });
        handleChangeStep(2);
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {}
  };

  const onChange = (e) => {
    setIsRead(e.target.checked);
  };

  const onFinishFailed = () => {};
  return (
    <>
      <Form
        colon={false}
        hideRequiredMark
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className="login-form"
      >
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập Số điện thoại",
            },
          ]}
        >
          <Input placeholder="Nhập Số điện thoại" className="input-login" />
        </Form.Item>
        <Form.Item>
          <Checkbox checked={isRead} onChange={onChange}>
            <span>
              Tôi đã đọc và đồng ý với
              <Link to={routePage.HELP.FAQS_HELP} className="term-policy">
                điều kiện và điều khoản của chương trình
              </Link>
              trở thành đối tác của Mytour và đồng ý với việc dữ liệu cá nhân
              của tôi được xử lý theo
              <a
                href="https://mytour.vn/news/135152-chinh-sach-va-quy-dinh-chung.html"
                target="_blank"
                rel="noopener noreferrer"
                className="term-policy"
              >
                Chính sách quyền riêng tư
              </a>
              của Mytour.
            </span>
          </Checkbox>
        </Form.Item>
        <Form.Item style={{ marginBottom: "16px" }}>
          <Button
            disabled={!isRead}
            type="primary"
            htmlType="submit"
            className={`btn-login ${!isRead ? "btn-disable" : ""}`}
          >
            Đăng Ký
          </Button>
        </Form.Item>
      </Form>
      <div className="line-item register-box">
        <span>Đã có tài khoản?</span>
        <Button
          type="text"
          className="btn-forgot-pw btn-link-register"
          onClick={() => handleVisible("LOGIN_MODAL")}
        >
          Đăng nhập
        </Button>
      </div>
    </>
  );
};

export default RegisterStep1;
